var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplicant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.823,
    height: 116.803,
    viewBox: "0 0 116.823 116.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(-1.997 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline-2",
    "data-name": "Outline",
    transform: "translate(1.997 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1922",
    "data-name": "Path 1922",
    d: "M40.26,49.521a8.76,8.76,0,1,0-8.76-8.76,8.76,8.76,0,0,0,8.76,8.76Zm0-13.627a4.867,4.867,0,1,1-4.867,4.867A4.867,4.867,0,0,1,40.26,35.893Z",
    transform: "translate(25.934 26.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1923",
    "data-name": "Path 1923",
    d: "M22,55.254A27.254,27.254,0,1,0,49.254,28,27.254,27.254,0,0,0,22,55.254Zm14.6,19.6A13.16,13.16,0,0,1,49.254,61.094,13.16,13.16,0,0,1,61.908,74.858,23.185,23.185,0,0,1,36.6,74.858ZM49.254,31.893A23.361,23.361,0,0,1,65.587,71.938,16.859,16.859,0,0,0,49.254,57.2,16.859,16.859,0,0,0,32.941,71.938,23.361,23.361,0,0,1,49.254,31.893Z",
    transform: "translate(16.941 22.615)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1924",
    "data-name": "Path 1924",
    d: "M112.966,25.361h-3.893V15.627a1.947,1.947,0,0,0-1.947-1.947H95.446V3.947A1.947,1.947,0,0,0,93.5,2H11.737A1.947,1.947,0,0,0,9.79,3.947V25.361H9.167A7.5,7.5,0,0,0,2,33.148v77.713A7.651,7.651,0,0,0,9.284,118.8H111.818a7.514,7.514,0,0,0,6.989-7.943V31.2A5.84,5.84,0,0,0,112.966,25.361Zm0,3.893a1.947,1.947,0,0,1,1.947,1.947v9.734h-5.84V29.254Zm-7.787,11.68H65a1.616,1.616,0,0,1-1.11-.448L49.445,26.86a5.509,5.509,0,0,0-3.777-1.5H27.31V17.574h77.869ZM5.9,110.861V33.148a3.621,3.621,0,0,1,3.27-3.893H9.79V109.07a1.947,1.947,0,0,0,1.947,1.947h5.84a8.6,8.6,0,0,0,.993,3.893H9.284A3.757,3.757,0,0,1,5.9,110.861Zm109.017,0a3.718,3.718,0,0,1-3.1,4.049H24.565a3.718,3.718,0,0,1-3.1-4.049V77.922a1.947,1.947,0,1,0-3.893,0v29.2H13.683V5.893H91.552V13.68H25.364a1.947,1.947,0,0,0-1.947,1.947v9.85a7.534,7.534,0,0,0-5.84,7.67v29.2a1.947,1.947,0,1,0,3.893,0v-29.2a3.582,3.582,0,0,1,2.978-3.893H45.668a1.616,1.616,0,0,1,1.11.448L61.222,43.329A5.509,5.509,0,0,0,65,44.847h49.914Z",
    transform: "translate(-1.997 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1925",
    "data-name": "Path 1925",
    d: "M32.947,16.893H71.881a1.947,1.947,0,0,0,0-3.893H32.947a1.947,1.947,0,1,0,0,3.893Z",
    transform: "translate(25.461 8.414)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1926",
    "data-name": "Path 1926",
    d: "M67.148,17h-29.2a1.947,1.947,0,0,0,0,3.893h29.2a1.947,1.947,0,1,0,0-3.893Z",
    transform: "translate(30.195 12.201)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 1.5,
    cy: 2,
    rx: 1.5,
    ry: 2,
    transform: "translate(16 66)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicant);
export default __webpack_public_path__ + "static/media/Applicant.ba9fd04257c49b74818e24c5ceae0a66.svg";
export { ForwardRef as ReactComponent };